/* import __COLOCATED_TEMPLATE__ from './user-became-idle.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    part: any;
  };
}

const UserBecameIdleComponent = templateOnlyComponent<Signature>();
export default UserBecameIdleComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::UserBecameIdle': typeof UserBecameIdleComponent;
    'inbox2/conversation-stream/event-parts/user-became-idle': typeof UserBecameIdleComponent;
  }
}
